export default __webpack_public_path__ + "static/media/aaveg.e245463b.svg";